import React from 'react';
import {FormattedMessage} from "react-intl";

import {LOCALE} from "features/ui/enums";
import {useDeviceStore, selectIsMobile} from "features/ui/store/useDeviceStore";
import {getCurrentLocale} from "features/services/utils/env-helper";
import {useModal} from "features/modal/hooks/useModal";
import {ObjectStatus, StageStatus} from "features/search/filters/enums";
import {getFormattedMessage} from "features/services/utils/language-helper";
import {useResidenceExplorerStore, selectCurrentView, selectSetup} from "features/residenceExplorer/store/useResidenceExplorerStore";

import './_residenceExplorerHeaderControls.scss'

import {Icon} from "@atoms/Media/Icon";
import {Switch} from "@atoms/FormElements/Switch";
import {Button, ButtonColor, ButtonSize, ButtonType} from "@atoms/LinksAndButtons/Button";
import {UserAgent} from "@atoms/UserAgent";
import {SiteSpecificContent} from "@atoms/SiteSpecificContent";
import {
    ResidenceExplorerMobileFilterButton
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceEplorerMobileFilterButton";
import {
    ResidenceExplorerStatusDescriptionModal
} from "components/modals/ResidenceExplorer/_residenceExplorerStatusDescriptionModal";
import { Tags, TagDesign } from '@atoms/Tags/Tags';


export const ResidenceExplorerHeaderControls: React.FC = () => {
    const { open } = useModal();
    const isMobile = useDeviceStore(selectIsMobile);
    const currentView = useResidenceExplorerStore(selectCurrentView);
    const settings = useResidenceExplorerStore(selectSetup);
    const setHideObjects = useResidenceExplorerStore(state => state.setHideObjects);

    if (!settings) return null;

    const onStatusClick = () => {
        const { stageStatus, hideSoldObjects } = settings;

        open(
            <ResidenceExplorerStatusDescriptionModal
                hideSoldObjects={hideSoldObjects}
            />,
            { fullscreen: false, triggerElementId: 'residenceExplorerStatuses' }
        );
    };

    const onHideResidences = (checked: boolean) => {
        setHideObjects(checked);
    };

    return (
        <div className="residence-explorer-header-controls">
            <Button
                id='residenceExplorerStatuses'
                onClick={onStatusClick}
                className="residence-explorer-header-controls__statuses"
                icon={<Icon name="info" />}
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.NO_STYLE} 
            >
                <span className={!isMobile ? "visually-hidden" : ""}>
                    <FormattedMessage id="jm.components.ResidenceExplorer.readMoreStatuses" />
                </span>
                {!isMobile && <span aria-hidden="true">
                    <Tags 
                        tagDesign={TagDesign.DOT} 
                        status={ObjectStatus.FOR_SALE} 
                        className='status' 
                    />
                    <Tags 
                        tagDesign={TagDesign.DOT} 
                        status={ObjectStatus.RESERVED} 
                        className='status' 
                    />

                    {getCurrentLocale() !== LOCALE.NO && (
                        <SiteSpecificContent notNorway>
                            <Tags 
                                tagDesign={TagDesign.DOT} 
                                status={ObjectStatus.BOOKED} 
                                className='status' 
                            />
                        </SiteSpecificContent>
                    )}

                    {!settings.hideSoldObjects && (
                        <Tags 
                            tagDesign={TagDesign.DOT} 
                            status={ObjectStatus.SOLD} 
                            className='status' 
                        />
                    )}
                </span>}
            </Button>
            <UserAgent computer tablet>
            </UserAgent>

            {/* <UserAgent mobile>
                <span className="read-more-statuses" onClick={onStatusClick} >
                    <span><FormattedMessage id="jm.components.ResidenceExplorer.readMoreStatuses" /></span>
                    <Icon name="info" />
                </span>
            </UserAgent> */}

            <div className="residence-explorer-header-controls__toggle">
                <UserAgent mobile tablet>
                    <ResidenceExplorerMobileFilterButton />
                </UserAgent>

                <UserAgent computer>
                    {(currentView !== null && currentView !== undefined) && (
                        <Switch
                            label={getFormattedMessage('jm.components.ResidenceExplorer.hideResidences')}
                            onClick={onHideResidences}
                        />
                    )}
                </UserAgent>
            </div>
        </div>
    );
};
